import { App as Application } from 'vue'
import {
  Button,
  Pagination,
  Image,
  Spin,
  Divider,
  Input
} from 'ant-design-vue'

export default {
  install: (app: Application): void => {
    app.use(Button)
    app.use(Pagination)
    app.use(Image)
    app.use(Spin)
    app.use(Divider)
    app.use(Input)
  }
}
